import React, { useEffect } from "react";
import { orgActions } from "../../actions";
import { connect } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { IngestorNav } from "./IngestorNav";
import moment from "moment";
import humanizeDuration from "humanize-duration";

function IngestionPage(props) {
  const { org, authentication, getIngestionStats, getOcrInfo } = props;
  const org_id =
    org?.current_org_id === null
      ? authentication.user.org_id
      : org.current_org_id;
  const { id } = useParams();

  const status_green = require("../../images/status-green.png").default;
  const status_red = require("../../images/status-red.png").default;
  const status_blue = require("../../images/status-blue.png").default;
  const refresh_icon = require("../../images/refresh.png").default;

  useEffect(() => {
    getIngestionStats(id);
    getOcrInfo(id);
  }, [id]);

  const headers = [
    "ingestion run id",
    "type",
    "initiator",
    "item_limit",
    "success count",
    "fault count",
    "completed",
    "total processing time",
  ];

  const tableHeaders = headers.map((header, i) => <th>{header}</th>);

  function calculateStatusImage(stat_row) {
    if (stat_row.fault_count > 0) return status_red;
    if (stat_row.end_time === null || stat_row.success_count === 0) {
      return status_blue;
    }
    return status_green;
  }

  function refreshStats() {
    getIngestionStats(org_id);
  }

  const tableRows = !org.ingestion_stats
    ? null
    : org.ingestion_stats.map((stat_row, i) => (
        <tr>
          <td>
            <img
              src={calculateStatusImage(stat_row)}
              class="statusImage"
              alt="status image"
            />
            {
              <Link to={"/ingestion/run/" + stat_row.ingestion_run_id}>
                {stat_row.ingestion_run_id}
              </Link>
            }
          </td>
          <td>{stat_row.ingestion_run_type}</td>
          <td>{stat_row.user_id}</td>
          <td>{stat_row.item_limit}</td>
          <td className="happyMessage">{stat_row.success_count}</td>
          {!(stat_row.fault_count === 0) && (
            <td className="errormessage">{stat_row.fault_count}</td>
          )}
          {stat_row.fault_count === 0 && <td>{stat_row.fault_count}</td>}

          <td>
            {stat_row.end_time ? moment(stat_row.end_time).calendar() : ""}
          </td>
          <td>
            {stat_row.end_time
              ? humanizeDuration(
                  new Date(stat_row.end_time) - new Date(stat_row.start_time)
                )
              : ""}
          </td>
        </tr>
      ));

  return (
    <>
      <br />

      <div class="refresh">
        {org.ingestion_stats?.length > 0 && (
          <img src={refresh_icon} class="refreshIcon" onClick={refreshStats} alt="refresh" />
        )}
      </div>
      <div class="searchMain">
        <div class="contentContainerLeftNav">
          <div class="leftNav">
            <IngestorNav parent="overview" />
          </div>
          <div class="rightContent">
            {org.ingestion_stats?.length > 0 && (
              <table class="paleBlueRows">
                <tbody>
                  {tableHeaders}
                  {tableRows}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org,
  };
}

const actionCreators = {
  getIngestionStats: orgActions.getIngestionStats,
  getOcrInfo: orgActions.getOcrInfo,
};

const connectedIngestionPage = connect(
  mapStateToProps,
  actionCreators
)(IngestionPage);
export { connectedIngestionPage as IngestionPage };
